<template>
  <ion-page>
    <ion-header class="ion-text-center">
      <ion-toolbar>
        <ion-title>
          Parametri di ricerca
        </ion-title>
        <ion-button @click="close()" color="primary" fill="clear" slot="end">
          <ion-icon icon="close" />
        </ion-button>
      </ion-toolbar>
    </ion-header>
    <ion-content fullscreen>
      <ion-fab slot="fixed" vertical="bottom" horizontal="end">
        <ion-fab-button color="secondary" @click="search()">
          <ion-icon name="play" />
        </ion-fab-button>
      </ion-fab>
      <ion-grid>
        <ion-row>
          <ion-col size="12">
            <ion-input type="search" v-model="optText">
              <ion-icon name="search" class="ion-margin-start" />
            </ion-input>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-radio-group v-model="optType">
              <ion-grid>
                <ion-row>
                  <ion-col
                    v-for="qt of tipiQuery"
                    :key="qt.value"
                    size="4"
                    class="ion-no-padding"
                  >
                    <ion-item lines="none">
                      <ion-label class="ion-text-center">{{
                        qt.label
                      }}</ion-label>
                      <ion-radio :value="qt.value"></ion-radio>
                    </ion-item>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ion-radio-group>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-item>
              <ion-label>Materie</ion-label>
              <ion-select
                v-model="optMaterie"
                interface="popover"
                @ionChange="changeMateria"
                multiple="true"
                cancel-text="Annulla"
              >
                <ion-select-option
                  v-for="m of materie"
                  :key="m.value"
                  :value="m.value"
                  >{{ m.label }}</ion-select-option
                >
              </ion-select>
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-item>
              <ion-label></ion-label>
              <ion-select
                v-model="optArgomenti"
                interface="popover"
                multiple="true"
                cancel-text="Annulla"
                :disabled="argomenti.length == 0"
              >
                <ion-select-option
                  v-for="a of argomenti"
                  :key="a.value"
                  :value="a.value"
                  lines="none"
                  >{{ a.label }}</ion-select-option
                >
              </ion-select>
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-item>
              <ion-label>Ordina per</ion-label>
              <ion-select
                v-model="optTipoOrdinamento"
                interface="popover"
                lines="none"
              >
                <ion-select-option
                  v-for="o of tipiOrdinamento"
                  :key="o.value"
                  :value="o.value"
                  >{{ o.label }}</ion-select-option
                >
              </ion-select>
            </ion-item>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import { mapState, useStore } from 'vuex';
import { Picklist } from '../../models/picklist.model';
import { document, close, play } from 'ionicons/icons';
import { addIcons } from 'ionicons';
import { JnService } from '../../services/jn.service';
import { EsService } from '../../services/es.service';
import { Utils } from '../../services/utils';
import moment from 'moment';

import {
  SearchTypes,
  QueryTypes,
  OrderingTypes,
  Categories,
} from '../../models/enums.model';

addIcons({
  document: document,
  close: close,
  play: play,
});

import {
  IonContent,
  IonButtons,
  IonMenuButton,
  IonMenuToggle,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonGrid,
  IonRow,
  IonCol,
  IonRadioGroup,
  IonRadio,
  IonLabel,
  IonItemDivider,
  IonIcon,
  IonInput,
  IonItem,
  IonSelect,
  IonSelectOption,
  IonButton,
  modalController,
  IonDatetime,
  IonFab,
  IonFabButton,
} from '@ionic/vue';
import { SearchData } from '@/models/search.model';

export default defineComponent({
  name: 'JnAreaTematicaSearchParams',
  props: {
    searchData: {
      type: SearchData,
      required: true,
    },
  },
  components: {
    IonContent,
    IonItem,
    IonRadio,
    IonRadioGroup,
    IonGrid,
    IonCol,
    IonRow,
    IonLabel,
    // IonItemDivider,
    IonIcon,
    IonInput,
    IonToolbar,
    IonHeader,
    IonPage,
    IonTitle,
    IonSelect,
    IonSelectOption,
    IonButton,
    IonFab,
    IonFabButton,
  },

  setup(props) {

    const optMaterie = ref([] as Array<string>);
    const optArgomenti = ref([] as Array<string>);
    const optTags = ref([] as Array<string>);
    const optTipoDocumento = ref([] as Array<string>);
    const optText = ref('');
    const optType = ref(QueryTypes.OR);
    const optTipoOrdinamento = OrderingTypes.DATA_CREAZIONE;

    const tipiQuery = ref([] as Array<Picklist>);
    const tipiOrdinamento = ref([] as Array<Picklist>);

    const materie = ref([] as Array<Picklist>);
    const categorie = ref([] as Array<Picklist>);
    const argomenti = ref([] as Array<Picklist>);
    const areeTematiche = ref([] as Array<Picklist>);
    const tags = ref([] as Array<Picklist>);
    const tipiDocumento = ref([] as Array<Picklist>);

    const searchData = ref(props.searchData);

    let areeTematicheRaw!: any;
    let tagsRaw!: any;

    onMounted(async () => {
      tipiQuery.value = JnService.getQueryTypes();
      tipiOrdinamento.value = JnService.getTipiOrdinamento();
      tipiDocumento.value = JnService.getTipiDocumento();

      areeTematicheRaw = JSON.parse(
        await EsService.getOptions('struttura-aree-tematiche')
      );

      for (const areaTematica of areeTematicheRaw['aree-tematiche']) {
        areeTematiche.value.push(
          new Picklist({ label: areaTematica.name, value: areaTematica.id })
        );
        if (areaTematica.id == searchData.value.idAreaTematica) {
          for (const materia of areaTematica.materie) {
            materie.value.push(
              new Picklist({ label: materia.name, value: materia.id })
            );
          }
        }
        materie.value.sort(Utils.sort('label', 'asc'));
      }
      tagsRaw = JSON.parse(await EsService.getOptions('tags'));
      for (const tag of tagsRaw) {
        if (tag.value != 'ROOT') {
          tags.value.push(new Picklist({ value: tag.id, label: tag.value }));
        }
      }
    });

    const search = async () => {
      searchData.value.keywords = optText.value;
      searchData.value.queryType = optType.value;
      if (optTipoOrdinamento) {
        searchData.value.orderingType = optTipoOrdinamento;
      }

      const idMaterie: string[] = [];
      for (const m of optMaterie.value) {
        idMaterie.push(m);
      }
      searchData.value.idMateria = idMaterie;

      const idArgomenti: string[] = [];
      for (const a of optArgomenti.value) {
        idArgomenti.push(a);
      }
      searchData.value.idArgomento = idArgomenti;

      const tags: string[] = [];
      for (const t of optTags.value) {
        tags.push(t);
      }
      searchData.value.tags = tags;

      const tipiDocumento: string[] = [];
      for (const td of optTipoDocumento.value) {
        tipiDocumento.push(td);
      }
      searchData.value.idCategory = tipiDocumento;

      modalController.dismiss(searchData);
    };

    const close = async () => {
      modalController.dismiss(undefined);
    };
/*
    const clear = async () => {
      optText.value = '';
      optType.value = QueryTypes.OR;
      optMaterie.value = [];
      optTipoOrdinamento = OrderingTypes.DATA_CREAZIONE;
      optArgomenti.value = [];
      optTags.value = [];
      optTipoDocumento.value = [];
    };
*/
    const changeMateria = async () => {
      argomenti.value = [];
      optArgomenti.value = [];
      for (const selectedMateria of optMaterie.value) {
        for (const areaTematica of areeTematicheRaw['aree-tematiche']) {
          for (const materia of areaTematica.materie) {
            if (materia.id == selectedMateria) {
              for (const argomento of materia.argomenti) {
                argomenti.value.push(
                  new Picklist({ label: argomento.name, value: argomento.id })
                );
              }
            }
          }
        }
      }
    };

    return {
      tipiQuery,
      optArgomenti,
      optMaterie,
      optText,
      optType,
      optTipoOrdinamento,
      tipiOrdinamento,
      categorie,
      changeMateria,
      materie,
      argomenti,
      search,
      close,
    };
  },
});
</script>
